// @flow
import React, { Component } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import { BrandedStyledLink } from '../../components/LinkStyles';
import {
  SignUpDiv,
  SignUpBackground,
  SignUpH1,
  SignInP
} from './SignUpStyles';

type Props = {
  t: TFunction
};

class SignUp extends Component<Props> {
  render() {
    const { t } = this.props;

    return (
      <SignUpBackground>
        <SignUpDiv>
          <SignUpH1>{t('signup.closed.title')}</SignUpH1>
          <SignInP>{t('signup.closed.message')}</SignInP>
          <SignInP>
            <BrandedStyledLink to="/signin" underline>
              {t('signup.closed.signIn')}
            </BrandedStyledLink>
          </SignInP>
        </SignUpDiv>
      </SignUpBackground>
    );
  }
}

export default withTranslation(['unauthenticated'])(SignUp);
